import { Container } from "@mui/system";
import { Typography, Paper, Grid, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Page from "../components/Page";
import SalesTable from "../components/SalesTable";

//Hooks
import { useCollection } from "../hooks/useCollection";

function Sales() {
  const navigate = useNavigate();

  const { documents } = useCollection("Sale");

  console.log("documents", documents);

  return (
    <Page title={"Sales"}>
      <Container maxWidth="xl">
        <Paper elevation={6} sx={{ p: 4 }}>
          <Grid
            container
            spacing={3}
            sx={{ justifyContent: "space-between", marginBottom: 1 }}
          >
            <Grid item xs={12} sm={6} md={6}>
              <Typography variant="h4" sx={{ mb: 1 }}>
                Sales
              </Typography>
            </Grid>
          </Grid>

          <Grid
            container
            spacing={3}
            sx={{ justifyContent: "space-between", marginBottom: 1, mt: 1 }}
          >
            <Grid item xs={12} sm={3} md={3}>
              <Button
                variant="contained"
                size="large"
                onClick={() => navigate(`/dashboard/add-sales/:id`)}
              >
                Create Sales
              </Button>
            </Grid>
          </Grid>
          <SalesTable data={documents} />
        </Paper>
      </Container>
    </Page>
  );
}

export default Sales;
